<template>
  <FieldWrapper
    :block="block"
    :step="step"
    v-on:update="update"
    @delete="$emit('delete')"
    label="Champ Upload"
    v-on:up="$emit('up')"
    v-on:down="$emit('down')"
  >
    <template v-slot:view>
      <v-list dense>
        <v-list-item>
          <v-list-item-content>Nom du champ:</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.name }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>Etiquette:</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.label }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>Obligatoire ?</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.required ?'Oui':'Non' }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>Multiple ?</v-list-item-content>
          <v-list-item-content
            class="align-end"
          >{{ block.fieldObject.config.multiple ?'Oui':'Non' }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>Utilisé pour le prix ?</v-list-item-content>
          <v-list-item-content class="align-end">{{ block.fieldObject.config.payable ?'Oui':'Non' }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <template v-slot:form="{field}">
      <v-container>
        <v-row>
          <v-col>
            <v-text-field v-model="field.name" label="Nom du champ" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field v-model="field.label" label="Etiquette" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox v-model="field.required" label="Obligatoire ?" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox v-model="field.config.multiple" label="Multiple ?" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-checkbox v-model="field.config.payable" label="Utilisé pour le prix ?" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea v-model="field.hint" label="Astuce / Tips / info" />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </FieldWrapper>
</template>

<script>
import iField from "./iField.vue";
export default {
  mixins: [iField],
  name: "FieldUpload"
};
</script>
